import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import MoneyFormat from "Base/MoneyFormat";

export default class BaseBetContainer extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.incativeTintColor = 0xCCCCCC;

        this.interactive = true;
        this.buttonMode = true;

        this.valuesRange = null;
        this.valueText = null;
        this.currentValue = 0;

        this._enabled = false;

        this.init();
        this.addListeners();
        this.addActions();
    }

    setRange(valuesRange) {
        this.valuesRange = valuesRange;
        this.betProgressContainer.setRange(this.valuesRange);
    }

    init() {
        this.decreaseButton = this.getChildByName('decreaseButton');
        this.valueText = this.getChildByName('valueText');
        this.increaseButton = this.getChildByName('increaseButton');
        this.betProgressContainer = this.getChildByName('betProgressContainer');

        this.disableButtons();
    }

    addListeners() {
        this.on('pointertap', this.onClick, this);
    }

    addActions() {
        this.decreaseButton.actions = {
            click: {
                callback: this.onButtonClick, context: this, params: 'decrease'
            },
            touchend: {
                callback: this.onButtonClick, context: this, params: 'decrease'
            }
        };
        this.increaseButton.actions = {
            click: {
                callback: this.onButtonClick, context: this, params: 'increase'
            },
            touchend: {
                callback: this.onButtonClick, context: this, params: 'increase'
            }
        }
    }

    onClick(event) {
        if (event.target === this.decreaseButton || event.target === this.increaseButton) {
            return;
        }
        GlobalDispatcher.dispatch('betPanel:switchPopup');
    }

    onButtonClick(data) {
        GlobalDispatcher.dispatch('ui:changeBet', data);
    }

    setValue(value) {
        this.currentValue = value;
        this.valueText.text = MoneyFormat.format(this.currentValue);
        this.betProgressContainer.setValue(this.currentValue);
        this.checkButtonsToEnable();

        this.valueText.scale.set(1);
        if (this.valueText.origWidth > this.valueText.width) {
            this.valueText.origWidth = this.valueText.width;
            this.valueText.scale.set(this.valueText.scale.x);
        }
    }

    checkButtonsToEnable() {
        this.decreaseButton.enabled = this.valuesRange.indexOf(this.currentValue) > 0;
        this.increaseButton.enabled = this.valuesRange.indexOf(this.currentValue) < this.valuesRange.length - 1;
    }

    disableButtons() {
        this.decreaseButton.enabled = false;
        this.increaseButton.enabled = false;
    }

    enableButtons() {
        this.checkButtonsToEnable();
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
        this.interactive = value;
        this.children.forEach((child)=>{
            child.tint = this._enabled ? 16777215 : this.incativeTintColor;
        });

        this.betProgressContainer.enabled = this._enabled;
        if(!this._enabled) {
            this.disableButtons();
        } else {
            this.enableButtons();
        }
    }
}